module.exports = __webpack_public_path__ + "static/img/bird3.2c6d64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird3.png
// module id = Kf01
// module chunks = 1